import Validator from "validatorjs";

export const isValidEmail = (email: string) => {
  const rules = {
    email: "required|email",
  };
  const validation = new Validator({ email }, rules);

  if (validation.passes()) {
    return true;
  } else {
    return false;
  }
};

export const validatePasswordFormat = (password: string) => {
  if (password.length < 8) {
    return false;
  }

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return hasLetter && hasNumber && hasSpecialChar;
};

//INFO: HTML 태그를 제거하고 텍스트만 추출
export const extractHtmlText = (html?: string) => {
  const htmlTags = html?.match(/<[^>]+>/g); // 모든 HTML 태그 추출
  // HTML 태그를 제거한 텍스트 추출
  const textContent = html?.replace(/<[^>]+>/g, "").trim(); // 태그를 제거한 후 텍스트만 남김

  return {
    html: htmlTags ? htmlTags.join("") : "", // HTML 태그를 하나의 문자열로 결합
    text: textContent, // 남은 텍스트
  };
};

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
